export const CLASS_NAME_COMPONENT_BUTTON = "tg-selector-button";
export const CLASS_NAME_COMPONENT_BUTTON_GROUP = "tg-selector-button-group";
